export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const LANDING = '/'
export const SHOPPING = '/shopping'
export const ACCOUNT = '/account'
export const PASSWORD_FORGET = './pw-forget'



// WEBPACK FOOTER //
// ./src/constants/routes.js